"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const FontIcon = (0, react_1.forwardRef)(({ id, className, onClick, "aria-label": iconLabel, tabIndex, icon: Icon, role = "img", "aria-hidden": ariaHidden, "data-testid": dataTestId }, iconRef) => {
    const isIconFunction = typeof Icon === "function";
    const iconClassName = isIconFunction ? "" : Icon;
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    (0, jsx_runtime_1.jsx)("span", Object.assign({ "aria-hidden": ariaHidden, className: (0, classnames_1.default)(className, "fa", iconClassName), onClick: onClick, ref: iconRef, "aria-label": iconLabel, tabIndex: tabIndex, role: role, id: id, "data-testid": dataTestId }, { children: isIconFunction && (0, jsx_runtime_1.jsx)(Icon, {}) })));
});
exports.default = FontIcon;
